import type { FieldOption, NumericField } from './types';

export const toFieldLabel = (
  fields: NumericField[],
  fieldName: string | null
): string =>
  fieldName === null
    ? ''
    : (fields.find(({ name }) => name === fieldName)?.label ?? fieldName);

/** Fields as the settings bar offers them, falling back to the name for a field with no label. */
export const toFieldOptions = (
  fields: { name: string; label: string }[]
): FieldOption[] =>
  fields.map(({ name, label }) => ({ name, label: label || name }));
